import { generatePath } from 'react-router-dom';

import { BANKING } from '#client/constants/navItemsIds';
import * as ROUTES from '#client/constants/routes';

import { processMenu } from '../utils/menu';

/**
 * Get the banking menu items.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: Set<string>
 * }} params
 * @returns {Array}
 */
export function getBankingMenuItems({ businessEntityUuid, entitlements }) {
  const hasBanking = entitlements.has('banking');

  return [
    {
      order: 10,
      title: 'Overview',
      itemId: 'banking_overview',
      path: generatePath(ROUTES.entityBanking, { businessEntityUuid, '*': 'dashboard' }),
    },
    {
      order: 20,
      show: hasBanking,
      title: 'Statements',
      itemId: 'banking_statements',
      path: generatePath(ROUTES.entityBanking, { businessEntityUuid, '*': 'statements' }),
    },
    {
      order: 30,
      show: hasBanking,
      title: 'Payees',
      itemId: 'banking_payees',
      path: generatePath(ROUTES.entityBanking, { businessEntityUuid, '*': 'payees' }),
    },
    {
      order: 40,
      show: hasBanking,
      title: 'Connected Accounts',
      itemId: 'banking_accounts',
      path: generatePath(ROUTES.entityBanking, { businessEntityUuid, '*': 'connected-accounts' }),
    },
  ];
}

/**
 * Get the banking menu.
 *
 * @param {{
 *  businessEntityUuid: string
 *  entitlements: string
 *  order?: number,
 * }} params
 * @returns {object}
 */
export function getBankingMenu({ businessEntityUuid, entitlements, order, ldFlags }) {
  return processMenu({
    title: 'Banking',
    itemId: BANKING,
    icon: 'temple-fill.svg',
    links: getBankingMenuItems({
      businessEntityUuid,
      entitlements,
      ldFlags,
    }),
    order,
  });
}
